import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import classes from "./TopHeader.scss";
import {
  SegmentControl,
  Button,
  ChecklistDropdown,
  ButtonDisclosure,
} from "@toddle-edu/ds-web";
import { ToddleIcon, LeftIcon } from "SvgComponents";
import { REGION_FILTER_OPTIONS } from "Platform/routes/Regions/modules/Module";
import { getSelectedRegions } from "Tooling/modules/ToolingModule";
import { onEnterOrSpaceKeyDown } from "Utils";

export const getTabs = feedAnalytics => {
  const allSchoolsCount = _.get(feedAnalytics, "TOTAL", 0);
  const transitionSchoolsCount = _.get(feedAnalytics, "TRANSITION", 0);
  return [
    {
      key: "ALL_SCHOOLS",
      label: `All schools ${allSchoolsCount}`,
      value: "ALL_SCHOOLS",
    },
    {
      key: "TRANSITION",
      label: `Transition ${transitionSchoolsCount}`,
      value: "TRANSITION",
    },
  ];
};

const TopHeader = props => {
  const {
    goToBack,
    onClickAdd,
    activeTab,
    updateOrganizationFilters,
    feedAnalytics,
    isCreateOrganizationEnabled,
    regionIds,
  } = props;

  const handleTabChange = value => {
    updateOrganizationFilters({ tab: value, plan: "" });
  };

  const handleRegionChange = regionIds => {
    updateOrganizationFilters({ regionIds });
  };

  const selectedRegions = getSelectedRegions({ regionIds });

  return (
    <div className={classes.container}>
      <div className={classes.leftContainer}>
        <div
          className={classes.leftIcon}
          onClick={goToBack}
          role="button"
          tabIndex={0}
          onKeyDown={e => onEnterOrSpaceKeyDown(e, () => goToBack())}
          aria-label="Go back"
        >
          <LeftIcon />
          <ToddleIcon />
        </div>
        <div className={classes.title}>{`Schools`}</div>
      </div>
      <div className={classes.centerContainer}>
        <SegmentControl
          value={activeTab}
          options={getTabs(feedAnalytics)}
          onChange={handleTabChange}
          size="x-large"
        />
      </div>
      <div className={classes.rightContainer}>
        <ChecklistDropdown
          value={regionIds}
          options={REGION_FILTER_OPTIONS}
          showAllOption
          onChange={handleRegionChange}
        >
          <ButtonDisclosure variant="outlined" size="large">
            Region: {selectedRegions}
          </ButtonDisclosure>
        </ChecklistDropdown>

        {isCreateOrganizationEnabled ? (
          <Button
            onClick={onClickAdd}
            size="large"
          >{`Create new school`}</Button>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    regionIds: state.tooling.organizationFilters.regionIds,
  };
};

export default connect(mapStateToProps)(TopHeader);
